module.exports = __webpack_public_path__ + "static/media/default.b9a86c50.jpeg";